import { render, staticRenderFns } from "./BusinessDay.vue?vue&type=template&id=2535d62e&scoped=true&"
import script from "./BusinessDay.vue?vue&type=script&lang=js&"
export * from "./BusinessDay.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDay.vue?vue&type=style&index=0&id=2535d62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535d62e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2535d62e')) {
      api.createRecord('2535d62e', component.options)
    } else {
      api.reload('2535d62e', component.options)
    }
    module.hot.accept("./BusinessDay.vue?vue&type=template&id=2535d62e&scoped=true&", function () {
      api.rerender('2535d62e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/components/BusinessDay.vue"
export default component.exports